import React from "react";
import {Field} from "formik";
import {TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import IconPicker from "../shared/IconPicker.js";

/**
 * Champs du formulaire Consigne (catalogue générique). Patron maison :
 * sectionContainer + lignes label (size 3) / contrôle (size 9).
 */
export default function ConsigneForm({values, errors, touched, handleChange, handleBlur, setFieldValue}) {
    return (
        <Grid container spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/* CODE */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Code <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.code}>
                        {({form}) => (
                            <TextField
                                error={Boolean(form.errors.code && form.touched.code)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.code}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="code"
                                label="Code"
                                helperText={
                                    (form.errors.code && form.touched.code && String(form.errors.code))
                                    || "Identifiant stable (ex. ACCES_TRAVAUX)"
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* LIBELLÉ FR */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé (FR) <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelleFr}>
                        {({form}) => (
                            <TextField
                                error={Boolean(form.errors.libelleFr && form.touched.libelleFr)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelleFr}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelleFr"
                                label="Libellé (FR)"
                                helperText={form.errors.libelleFr && form.touched.libelleFr && String(form.errors.libelleFr)}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* LIBELLÉ AR */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé (AR)
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelleAr}>
                        {({form}) => (
                            <TextField
                                error={Boolean(form.errors.libelleAr && form.touched.libelleAr)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelleAr || ""}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelleAr"
                                label="Libellé (AR)"
                                dir="rtl"
                                helperText={form.errors.libelleAr && form.touched.libelleAr && String(form.errors.libelleAr)}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* COULEUR */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Couleur <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="color" value={values.couleur}>
                        {({form}) => (
                            <TextField
                                error={Boolean(form.errors.couleur && form.touched.couleur)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.couleur}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                name="couleur"
                                label="Couleur"
                                type="color"
                                slotProps={{
                                    input: {style: {height: "3rem", padding: 0, width: "5rem"}},
                                    inputLabel: {shrink: true},
                                }}
                                helperText={form.errors.couleur && form.touched.couleur && String(form.errors.couleur)}
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* ICÔNE */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Icône <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <IconPicker
                        showLabel={false}
                        value={values.picto}
                        color={values.couleur}
                        onChange={(key) => setFieldValue("picto", key)}
                        error={touched.picto && errors.picto}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
